import { extendTheme } from '@mui/material/styles';
import defaultTokens from './default';
import overrides from './overrides';

const theme = extendTheme({
    ...defaultTokens,
    ...overrides,
});

export default theme;
